import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "button-config",
    templateUrl: "./button-config.view.html",
    providers: []
})
export class ButtonConfigView implements OnInit {
    baseUrl = "";
    buttonConfig: any = {};
    iconList = {
        cart: [
            {
                label: "Cart",
                class: "fa-cart-arrow-down",
                secondaryClass: "fa-cart-arrow-down"
            }
        ],
        fav: [
            {
                label: "Heart",
                class: "fa-heart",
                secondaryClass: "fa-heart-o"
            },
            {
                label: "Star",
                class: "fa-star",
                secondaryClass: "fa-star-o"
            }
        ],
        remove: [
            {
                label: "Remove",
                class: "fa-times",
                secondaryClass: "fa-times"
            },
            {
                label: "Eye Slash",
                class: "fa-eye-slash",
                secondaryClass: "fa-eye-slash"
            }
        ]
    };

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "speaker") {
            this.baseUrl = sharedService.sessionUrl;
            this.buttonConfig = this.sharedService.speakerLayoutConfig[this.baseUrl].catalogConfig.buttonConfig;
        }
    }

    ngOnInit() {}

    iconChange(e, prop1, prop2, type) {
        this.buttonConfig[prop1] = e.value;
        this.iconList[type].forEach((element) => {
            if (element.class == e.value) {
                this.buttonConfig[prop2] = element.secondaryClass;
            }
        });
    }

    toggleAddToCartButton(e) {
        this.buttonConfig.enableAddToCartButton = !this.buttonConfig.enableAddToCartButton;
    }
}
